import { useI18n } from '@/client/i18n/I18nContext';

interface CARONoteProps {
  note: string;
  /** Overrides the default localized label ('pdp.caroNote'). */
  label?: string;
}

/** CARO's editorial recommendation — the key differentiator. Visually distinct
 *  from official/manufacturer product information. */
export function CARONote({ note, label }: CARONoteProps) {
  const { t } = useI18n();
  return (
    <figure className="caro-note">
      <figcaption className="caro-note__label">{label ?? t('pdp.caroNote')}</figcaption>
      <p className="caro-note__body">{note}</p>
    </figure>
  );
}
